export default "__VITE_ASSET__rWZP47fl__"